export default "__VITE_ASSET__CyUyU1t3__"